import React, { useEffect, useState } from "react";
import { GiReturnArrow } from "react-icons/gi";
import { FaShoppingCart } from "react-icons/fa";
import { MdOutlineLabelImportant } from "react-icons/md";
import Image from "../../designLayouts/Image";
import Badge from "./Badge";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addToWishlist,
  addToCart,
  addToCompared,
  removeFromWishlist,
} from "../../../redux/orebiSlice";
// import { removeFromWishlist } from "../../../redux/orebiSlice";
import { Dialog, DialogBody } from "@material-tailwind/react";
// import { products } from "../Products/data/Product";
import ProductComparison from "./component/ProductComparison.js";
import WishlistIcon from "../../../pages/Wishlist/WishlistIcon";
// import { products, wishlist } from "../../../constants/index.js";
// import { paginationItems } from "../../../constants/index";
import axios from "axios";
const Product = (props) => {
  const [open, setOpen] = React.useState(false);

  // const handleCategoryChange = (event) => {
  //   // logika penanganan perubahan kategori
  // };
  const [buttonColor, setButtonColor] = useState(
    localStorage.getItem("buttonColor") || '#374151');
  const [wished, setWished] = useState(false);
  const wishlist = useSelector((state) => state.wishlist) || [];
  const isWished = wishlist.some((item) => item._id === props._id);

  const handleOpen = () => {
    setOpen(!open);
    handleAddToCompare();
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    axios
        .get(`https://erp.digitalindustryagency.com/api/wishlist`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const userData = response.data.data.resource;
          setWished(userData);
        })
        .catch((error) => {
          console.error("Error fetching user data profil:", error);
        });
  }, []);

  const handleAddToCompare = () => {
    dispatch(
      addToCompared({
        _id: props._id,
        productName: props.productName,
        image: props.img,
        price: props.price,
        colors: props.color,
        desc: props.des,
      })
    );
    console.log("Item added to compare:", {
      _id: props._id,
      productName: props.productName,
      image: props.img,
      price: props.price,
      colors: props.color,
      desc: props.des,
    });
    const productIds = localStorage.getItem("comparedProducts") || [];
    if (!productIds.includes(props._id)) {
      productIds.push(props._id);
      localStorage.setItem("comparedProducts", JSON.stringify(productIds));
    }
  };

  const dispatch = useDispatch();
  const id = props.content_title;
  const idString = (id) => {
    return String(id).toLowerCase().split(" ").join("");
  };

  const rootId = idString(id);
  const navigate = useNavigate();
  const productItem = props;
  const handleProductDetails = () => {
    navigate(`/product/${rootId}`, {
      state: {
        item: productItem,
      },
    });
  };
  const dispatchwish = useDispatch();

  const handleAddToWishlist = () => {
    const token = localStorage.getItem("accessToken");
    const user_id = localStorage.getItem("id");
    if (!token) {
      navigate("/signin");
      return;
    }
    axios
      .post(
        "https://erp.digitalindustryagency.com/api/wishlist",
        {
          user_id: user_id,
          content_id: props._id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("Data wishlist berhasil ditambahkan:", response.data);
        setWished(true);
        dispatch(addToWishlist({ _id: props._id }));
        const localStorageWishlist =
          JSON.parse(localStorage.getItem("wishlist")) || [];
        localStorageWishlist.push(props._id);
        localStorage.setItem("wishlist", JSON.stringify(localStorageWishlist));
        setButtonColor("#ff3e6c");
      })
      .catch((error) => {
        console.error("Error saat menambahkan data wishlist:", error);
        // ... penanganan error lainnya
      });
  };

  const handleRemoveFromWishlist = () => {
    const token = localStorage.getItem("accessToken");
    const user_id = localStorage.getItem("id");

    axios
      .delete(
        `https://erp.digitalindustryagency.com/api/wishlist/${user_id}/content/${props._id}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("Data wishlist berhasil dihapus:", response.data);

        // Update local state
        dispatchwish(
          removeFromWishlist({
            _id: props._id,
            productName: props.productName,
            image: props.img,
            price: props.price,
          })
        );

        // Update local storage
        const localStorageWishlist =
          JSON.parse(localStorage.getItem("wishlist")) || [];
        const updatedWishlist = localStorageWishlist.filter(
          (id) => id !== props._id
        );
        localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
        setButtonColor("#374151");
      })
      .catch((error) => {
        console.error("Error saat menghapus data wishlist:", error);
        // Handle other error cases
      });
  };

  const handleAddToCart = () => {
    dispatch(
      addToCart({
        _id: props._id,
        productName: props.productName,
        quantity: 1,
        image: props.img,
        badge: props.badge,
        price: props.price,
        colors: props.color,
      })
    );
    console.log("Item added to cart:", {
      _id: props._id,
      productName: props.productName,
      quantity: 1,
      image: props.img,
      badge: props.badge,
      price: props.price,
      colors: props.color,
    });
  };

  useEffect(() =>{
    localStorage.setItem('buttonColor', buttonColor)
  }, [buttonColor]);

  useEffect(() => {
    setWished(isWished);
  }, [isWished]);

  return (
    <div>
      <Dialog
        className="w-full h-[90%] rounded-lg overflow-auto touch-auto"
        open={open}
        size="xl"
        handler={handleOpen}
      >
        <DialogBody>
          <ProductComparison />
        </DialogBody>
      </Dialog>
      <div className="w-full relative group">
        <div className="max-w-80 max-h-80 relative overflow-y-hidden ">
          <div onClick={handleProductDetails}>
            <Image className="w-full h-full" imgSrc={props.img} />
          </div>
          <div className="absolute top-6 left-8">
            {props.badge && <Badge text="New" />}
          </div>
          <div className="w-full h-32 absolute bg-white -bottom-[130px] group-hover:bottom-0 duration-700">
            <ul className="w-full h-full flex flex-col items-end justify-center gap-2 font-titleFont px-2 border-l border-r">
              <li
                onClick={handleOpen}
                className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full"
              >
                Compare
                <span>
                  <GiReturnArrow />
                </span>
              </li>
              <li
                onClick={handleProductDetails}
                className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full"
              >
                View Details
                <span className="text-lg">
                  <MdOutlineLabelImportant />
                </span>
              </li>
              <li className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full">
                {buttonColor === "#ff3e6c" ? (
                  <>
                    Remove from Wishlist
                    <span onClick={handleRemoveFromWishlist}>
                      <WishlistIcon size={25} color={buttonColor} />
                    </span>
                  </>
                ) : (
                  <>
                    Add to Wishlist
                    <span onClick={handleAddToWishlist}>
                      <WishlistIcon size={25} color={buttonColor} />
                    </span>
                  </>
                )}
              </li>
            </ul>
          </div>
        </div>
        <div className="max-w-80 py-6 flex flex-col gap-1 border-[1px] border-t-0 px-4">
          <div className="justify-between font-titleFont">
            <p className="text-[#767676] text-[14px]">Rp. {props.price}</p>
            <h2 className="flex text-lg text-primeColor font-bold">
              {props.productName}
              <FaShoppingCart
                onClick={handleAddToCart}
                className="absolute left-auto right-3 text-[#767676] hover:text-primeColor hover:border-b-primeColor items-center justify-end gap-1 hover:cursor-pointer pb-1 duration-300 w-8 h-8"
              />
            </h2>
          </div>
          <div>
            {/* <p className="text-[#767676] text-[14px]">{props.color}</p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
